import React from 'react'
import styles from './LobbyDisconnection.module.css'
import useLobbyConnectionStatus from '@/src/hooks/data/useLobbyConnectionStatus'
import { MdWifiOff } from 'react-icons/md';
import ActiveGamesButton from '../ActiveGamesButton/ActiveGamesButton';
import { AnimatePresence, motion } from 'motion/react';

export default function LobbyDisconnection() {
    const { connected } = useLobbyConnectionStatus();

    return !connected ? (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={styles.container}>
            <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.5 }}
                className={styles.content}>
                <div className={styles.iconSection}>
                    <MdWifiOff className={styles.disconnectionIcon} size={56} />
                </div>
                <div className={styles.titleSection}>
                    <h1 className={styles.title}>Lobby Disconnected</h1>
                </div>
                <div className={styles.descriptionSection}>
                    <span className={styles.description}>
                        Please check your internet connection.<br />
                        Trying to reconnect...
                    </span>
                </div>
            </motion.div>
            <ActiveGamesButton absolute={true} />
        </motion.div>
    ) : null
}
